import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid min-h-full grid-cols-[auto_1fr] bg-white" };
const _hoisted_2 = { class: "flex min-w-0 flex-col gap-4 bg-white px-5 pt-6 pb-4" };
const _hoisted_3 = {
    class: "text-2xl font-bold text-(--colors-text-heading) sm:text-3xl",
    "data-testid": "value-list-detail-title"
};
import { computed, onMounted, shallowRef } from "vue";
import { useI18n } from "vue-i18n";
import { RouterLink, useRoute } from "vue-router";
import { moduleRegistry } from "@/router/moduleRegistry";
import ModuleState from "@/shared/components/ModuleState.vue";
import { valueListName } from "../../domain/valueList";
import { useValueListStore } from "../../stores/useValueListStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ValueListDetailPlaceholderView',
    setup(__props) {
        const { t, locale } = useI18n();
        const route = useRoute();
        const store = useValueListStore();
        onMounted(() => store.ensureLoaded());
        const SidebarComponent = shallowRef(moduleRegistry.getComponentForSlot("sidebar"));
        const code = computed(() => String(route.params.code));
        /** Until the lists load, or for a code no list carries, the code is the only name there is. */
        const title = computed(() => {
            const list = store.lists.find((candidate) => candidate.code === code.value);
            return list ? valueListName(list, locale.value) : code.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (SidebarComponent.value)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(SidebarComponent.value), { key: 0 }))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("main", _hoisted_2, [
                    _createVNode(_unref(RouterLink), {
                        to: { name: 'ValueListManager' },
                        class: "w-fit rounded-xs text-sm text-(--colors-text-link) hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--colors-text-link)",
                        "data-testid": "value-list-detail-back"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("valueLists.detail.back")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(title.value), 1 /* TEXT */),
                    _createVNode(ModuleState, {
                        type: "empty",
                        title: _unref(t)('valueLists.detail.comingSoon')
                    }, null, 8 /* PROPS */, ["title"])
                ])
            ]));
        };
    }
});
